import logo from '../../images/mobile/logo.png';
import logotext from '../../images/mobile/logotext.png';
import logoDesk from '../../images/desktop/logo.png';
import bgImageDesktopFigure from '../../images/desktop/bg-figure.png';
import bgImageTabletFigure from '../../images/tablet/figure-tablet.png';

export const lightTheme = {
  body: '#fff',
  MAIN_COLOR: '#212121',
  SECONDARY_COLOR: '#9B9FAA',
  TEXT_COLOR: '#fff',
  SECONDARY_TEXT_COLOR: '#212121',
  MOBILE_MENU_TEXT_COLOR: '#9B9FAA',
  MOBILE_MENU_ACTIVE_TEXT_COLOR: '#fff',
  CALORIES_TEXT_COLOR: '#264061',
  BACKGROUND_COLOR: '#E5E5E5',
  SIDEBAR_COLOR: '#F0F1F3',
  SIDEBAR_TEXT_COLOR: '#9B9FAA',
  BUTTON_COLOR: '#FC842D',
  LINE_COLOR: '#E0E0E0',
  INTAKE_DAILY_COLOR: '#264061',
  SELECT_CONTAINER_COLOR: '#FFF',
  SELECT_PLACEHOLDER_COLOR: '#212121',
  PRODUCT_LIST_THUMB_GRADIENT:
    'linear-gradient(0, rgba(255,255,255,1), rgba(255,255,255,0))',
  LOGO_MOBILE: logo,
  LOGO_TABLET: logotext,
  LOGO_DESKTOP: logoDesk,
  BG_FIGURE: bgImageDesktopFigure,
  BG_FIGURE_TABLET: bgImageTabletFigure,
  FILTER: 'invert(0)',
  ICONS_COLOR: '#9B9FAA',
  ICONS_COLOR_HOVER: '#212121',
  EDIT_BG_COLOR: '#F0F1F3',
};
